import { AbTestVariation } from './domain/models/ab-test-options.model';

export const A_TEST: [AbTestVariation] = [{ type: 'A' }];
export const AB_TEST: [AbTestVariation, AbTestVariation] = [{ type: 'A' }, { type: 'B' }];
